import '../../resources/css/settings/ModalLocalUpgrade.scss';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { openModalLoading, closeModal, closeModalLoading, openModalAlert } from '../../actions/index';
import FileUpload from '../common/FileUpload';
import { doLocalSoftwareUpdate, PRISMX_LOCAL_UPGRADE_INIT, PRISMX_LOCAL_UPGRADE_SUCCESS, PRISMX_LOCAL_UPGRADE_FAIL } from '../../actions/settings/index';

class ModalLocalUpgrade extends Component {

    componentDidUpdate(prevProps) {
        const { settingStatus, openModalLoading, closeModal, closeModalLoading, openModalAlert } = this.props;
        if (prevProps.settingStatus !== settingStatus) {
            if (settingStatus === PRISMX_LOCAL_UPGRADE_INIT) {
                openModalLoading('Updating the new software……<br/>It may take for about 10 minutes.<br/>Please keep this screen running during updating.', 'Update Software');
            }
            if (settingStatus === PRISMX_LOCAL_UPGRADE_SUCCESS) {
                closeModal(null);
            }
            if (settingStatus === PRISMX_LOCAL_UPGRADE_FAIL) {
                closeModalLoading();
                openModalAlert('Updating the new software fail');
            }
        }
    }

    render() {
        const { modalStatus, closeModal, doLocalSoftwareUpdate, authToken } = this.props;
        let show = modalStatus === 'localUpgrade', renderContent;

        if (show) {
            renderContent = (
                <Modal
                    show={show}
                    dialogClassName='area-modal-local-upgrade-view'
                    centered
                    onHide={() => {closeModal(null);}}
                >
                    <Modal.Body>
                        <div className='area-modal-local-upgrade-header'>
                            <Row>
                                <Col sm={7} className='area-modal-title'>
                                    <label>Update firmware</label>
                                </Col>
                                <Col sm={5} className='area-close-btn'>
                                    <span className='area-icon-close-detail' onClick={() => {closeModal(null);}}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-local-upgrade-content'>
                            <Row>
                                <Col sm={12}>
                                    <FileUpload type='application/x-gzip' 
                                                doAction={doLocalSoftwareUpdate} 
                                                token={authToken}
                                                nonDispatch={true}/>
                                </Col>
                            </Row>
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        } else {
            renderContent = (<div></div>);
        }

        return (
            <div className='area-modal-fileupload-view'>
                {renderContent}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        modalStatus: state.commonReducers.modalStatus,
        authToken: state.loginReducers.authToken,
        settingStatus: state.settingsReducers.status
    }
}

export default connect(
    mapStateToProps,
    { closeModal, openModalLoading, openModalAlert, closeModalLoading, doLocalSoftwareUpdate }
)(ModalLocalUpgrade)